
import LogsDS from '../../DataServices/LogsDs'; // ✅ fix path

const logs = new LogsDS();

export const insertLog = async (
  description, ID, email, hud, stopHudRotation, showAlert,
  activityId = '', activityType = '', activityService = '', activityStatus = '', activityErrorMsg = ''
) => {
  try {
    const idToken = localStorage.getItem('idToken');
    if (!idToken) {
      // Skip remote logging when user session is not established yet
      return;
    }

    const requestData = {
      activity_id: activityId,
      activity_type: activityType,
      activity_service: activityService,
      activity_status: activityStatus,
      activity_error_msg: activityErrorMsg,
      email,
      description,
      ID,
      addedTimeStamp: new Date().toISOString()
    };
    const response = await logs.RM_Activity_Logs_INSERT(requestData);
    const data = response.data;

    if (data.statusCode !== 200) {
      const message = data.body?.message || 'Log failed';
      console.error('Log insert failed:', message);
    }
  } catch (error) {
    const message = error?.response?.data?.message || error.message || 'Logging error';
    console.error('Logging error:', message);
  }
};
